import { Component } from '@angular/core';

@Component({
  selector: 'app-monthly-ranking-image',
  templateUrl: './monthly-ranking-image.component.html',
  styleUrls: ['./monthly-ranking-image.component.scss'],
})
export class MonthlyRankingImageComponent {}
